import { createWebHistory, createRouter } from "vue-router";

//导入组件
import newpcIndex from '@/pages/newIndex.vue'
import current from '@/pages/current.vue' // 当前展出
import Iconic from '@/pages/Iconic.vue' // 经典展览
import upcoming from '@/pages/upcoming.vue' // 即将展出
import details from '@/pages/details.vue' // 展览详情页

import Report from '@/pages/Report.vue' // 报道
import Photes from '@/pages/Photes.vue' // 图片
import Videos from '@/pages/Videos.vue' // 视频
import Around from '@/pages/Around.vue' // 全景
import mediadetails from '@/pages/mediadetails.vue' // 图片/视频详情页



import Events from '@/pages/Events.vue' // 公教活动
import Guided from '@/pages/Guided.vue' // 公益讲解
import artShop from '@/pages/artShop.vue' // 艺术品商店

import timeAddress from '@/pages/timeAddress.vue' // 时间和地址
import Introduction from '@/pages/Introduction.vue' // 美术馆简介
import team from '@/pages/team.vue' // 美术馆架构
import SearchResults from '@/pages/SearchResults.vue' // 搜索结果页面

import pcIndex from '@/pages/hIndex.vue'
// import search from '@/pages/search/index'

//定义路由规则
const routes = [
  { path: '/', name: 'newpcIndex', component: newpcIndex },
  { path: '/current', name: 'current', component: current },
  { path: '/Iconic', name: 'Iconic', component: Iconic },
  { path: '/upcoming', name: 'upcoming', component: upcoming },
  { path: '/details', name: 'details', component: details },
  { path: '/Report', name: 'Report', component: Report },
  { path: '/Photes', name: 'Photes', component: Photes },
  { path: '/Videos', name: 'Videos', component: Videos },
  { path: '/Around', name: 'Around', component: Around },
  { path: '/mediadetails', name: 'mediadetails', component: mediadetails },
  { path: '/Events', name: 'Events', component: Events },
  { path: '/Guided', name: 'Guided', component: Guided },
  { path: '/artShop', name: 'artShop', component: artShop },
  { path: '/timeAddress', name: 'timeAddress', component: timeAddress },
  { path: '/Introduction', name: 'Introduction', component: Introduction },
  { path: '/team', name: 'team', component: team },
  { path: '/search', name: 'SearchResults', component: SearchResults },
  
  { path: '/old', name: 'pcIndex', component: pcIndex },
  // { path: '/search', name: 'search', component: search, meta:{keepAlive: true} },
]

//创建路由对象
const router = createRouter({
  //用于记录路由的历史
  history: createWebHistory(),
  //用于定义多个不同路径和组件之间的对应关系
  routes
});
router.beforeEach((to, from, next) => {
  // 在路由改变前执行的操作
  window.scrollTo({ top: 0, behavior: 'smooth' });
  // 可以在这里进行权限检查等
  next(); // 必须调用 next() 来继续路由导航
});

//导出router
export default router
